import React from "react";
import "./TabsNavigation.scss";

const TabsNavigation = ({
    tabs = [],
    activeTab,
    onTabChange,
    className = "",
}) => {
    return (
        <nav className={`tabs-navigation ${className}`}>
            <ul className="tabs-navigation__list">
                {tabs.map((tab, index) => (
                    <li key={tab.id || index} className="tabs-navigation__item">
                        <button
                            className={`tabs-navigation__button ${
                                activeTab === tab.id
                                    ? "tabs-navigation__button--active"
                                    : ""
                            }`}
                            onClick={() => onTabChange(tab.id)}
                            type="button"
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default TabsNavigation;
